import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap } from '@cm/core/localization';

export type SPOtherRequirementsOutletLocNames = 'SPOtherRequirementsPageTitle';

export const spOtherRequirementsOutletLocs: LocDefs<SPOtherRequirementsOutletLocNames> = {
	SPOtherRequirementsPageTitle: {
		defaultValue: 'Other Requirements',
		description: 'The title of the page for viewing other requirements details.',
		displayPath: `Catalogs|Other Requirements|Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Title.PageTitle',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.OtherRequirement,
		portal: 'SP',
	},
};

export type SPOtherRequirementsOutletLocType = LocMap<SPOtherRequirementsOutletLocNames>;
